import React from 'react';
import { Box, Container, Typography } from '@mui/material';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
}

// Compact page header for subpages — replaces the old full-viewport hero so
// content is visible without scrolling.
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle }) => (
  <Box
    sx={{
      background: 'linear-gradient(135deg, #1B3C69 0%, #2B5999 100%)',
      color: 'white',
      py: { xs: 6, md: 8 },
      borderBottom: '4px solid',
      borderBottomColor: 'secondary.main',
    }}
  >
    <Container maxWidth="lg">
      <Typography
        variant="h1"
        component="h1"
        sx={{
          fontSize: { xs: '2rem', md: '2.75rem' },
          fontWeight: 700,
          lineHeight: 1.2,
          mb: subtitle ? 2 : 0,
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="h5"
          sx={{
            opacity: 0.9,
            fontWeight: 400,
            maxWidth: 640,
            fontSize: { xs: '1.05rem', md: '1.2rem' },
            lineHeight: 1.6,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Container>
  </Box>
);

export default PageHeader;
